<main class="dialog-create-user">
  
    <div>
        <h1
            mat-dialog-title class="dialog-create-user_title">
            <strong>
            {{"RegisterAlist" | translate}}
            </strong>
        </h1>

        <ng-template #loading>
            <div class="loading-container">
              <div  class="pulsing">
                <mat-spinner [diameter]="50" ></mat-spinner>
              </div>
              <p class="pulsing">{{"Loading" | translate}}...</p>
            </div>
          </ng-template>

          <div class="loading-container" *ngIf="!isLoadingSave">
            <div  class="pulsing">
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing">{{"Loading" | translate}}...</p>
          </div>

<mat-tab-group mat-stretch-tabs="false" *ngIf="graphDropdowns$| async as graphDropdowns; else loading" [ngClass]="{'contenido-deshabilitado': !isLoadingSave}">
  
  <mat-tab label= "{{ 'DataClientes' | translate }}">
      <!-- <ng-template matStepLabel>  {{"DataClientes" | translate}}</ng-template> -->
      <div mat-dialog-content class="dialog-create-user_content" >
        <form  [formGroup]="EditClientForm" >
          <div class="dialog-create-user_country">
            <h3  mat-dialog-subtitle class="dialog-create-user_subtitle" > ID:</h3>
            <h3 mat-dialog-subtitle class="dialog-create-user_subtitle1">{{client.CustomerId}}</h3>
          </div>

          <div class="dialog-create-user__wrapper">
              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label class="dialog-create-user__label"
                    >{{"FirstName" | translate}}</mat-label
                  >
                  <input 
                    matInput 
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    type="text"
                    formControlName="FirstName" 
                   
                  />
                </mat-form-field>
              </div>

              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label class="dialog-create-user__label"
                    >{{"LastName" | translate}}</mat-label
                  >
                  <input 
                    matInput 
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    type="text"
                    formControlName="LastName" 
                   
                  />
                </mat-form-field>
              </div>
      
              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label class="dialog-create-user__label"
                    >{{"email" | translate}}</mat-label
                  >
                  <input
                    matInput
                    type="text"
                    formControlName="email" 
                
                  />
                </mat-form-field>
                <div
                    *ngIf="
                      correoControl?.invalid &&
                      (correoControl?.touched || correoControl?.dirty)
                    "
                  >
                    <p
                      class="error-ms"
                      *ngIf="correoControl.errors?.['required']"
                    >
                      {{"ObligatoryField" |translate}}
                    </p>
                    <p
                      class="error-ms"
                      *ngIf="correoControl.errors?.['invalidEmail']"
                    >
                    {{"Invalidemail" |translate}}
                    </p>
                    <p
                    class="error-ms"
                    *ngIf="correoControl.errors?.['noSpecialChars']"
                  >
                  {{"noSpecialChars" |translate}}
                  </p>
                  </div>
              </div>

              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label 
                    class="dialog-create-user__label"
                  >
                    {{"PersonType" | translate}}
                  </mat-label>
                  <mat-select 
                    formControlName="tipoDePersona"
                  >
                    <mat-option
                      *ngFor="let typeOfPerson of personTypes"
                      [value]="typeOfPerson.typeId"
                    >
                    {{ typeOfPerson.typeName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
      
              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label 
                    class="dialog-create-user__label"
                  >
                    {{"Typededoc" | translate}}
                  </mat-label>
                  <mat-select
                  formControlName="typeDoc"
                  
                  >
                    <mat-option 
                      *ngFor="let typeOfDocument of documentTypesByPersonType"
                      [value]="typeOfDocument.typeId"
                    >
                    {{ typeOfDocument.typeName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label class="dialog-create-user__label"
                    >{{"Numberedoc" | translate}}</mat-label
                  >
                  <input 
                    matInput 
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    type="text"
                    formControlName="NumDoc"
                    maxlength="20"
                  />
                </mat-form-field>
              </div>
      
              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label class="dialog-create-user__label"
                    >{{"Phone" | translate}}</mat-label
                  >
                  <input
                    matInput
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    type="text"
                    formControlName="Phone"
                    maxlength="20"
                  />
                </mat-form-field>
              </div>

              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label 
                    class="dialog-create-user__label"
                  >
                  {{"Address" | translate}}
                  </mat-label>
                  <input
                    matInput
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    type="text"
                    formControlName="Address"
                    maxlength="40"             
                  />
                
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label 
                    class="dialog-create-user__label"
                  >
                  Sap ID
                  </mat-label>
                  <input
                    matInput
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    type="text"
                    formControlName="SapCoustomerID"
                    maxlength="40"             
                  />
                
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="mat-form-fieldwidth">
                  <mat-label 
                    class="dialog-create-user__label"
                  >
                    {{"RelationOwner" | translate}}
                  </mat-label>
                  <mat-select
                  formControlName="OwnerRelation"
                  >
                    <mat-option 
                    *ngFor="let RelationOwner of graphDropdowns[1]"
                    [value]="RelationOwner.relationshipVehicleId"
                    >
                    {{RelationOwner.relationshipName  | translate}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

          </div>

        </form>    
      </div>
    </mat-tab>
    <mat-tab label= "{{ 'dateVehicle' | translate }}">
        
        <div class="header-controls">
            <button
              mat-button
              *ngFor="let control of controls"
              (click)="createVehicle()"
            >
            <mat-label class="LabelColor">{{ "NewVehicle" | translate }}</mat-label> 
              <i [ngClass]="control.icon"></i>
            </button>
          </div>

            <table style="width: 100%;border-collapse: collapse;">
                <thead>
                <tr>
                    <th scope="col" style="border-bottom: 1px solid #ccc">{{ "Plate" | translate }}*</th>
                    <th scope="col" style="border-bottom: 1px solid #ccc">VIN*</th>
                    <th scope="col" style="border-bottom: 1px solid #ccc">{{ "Brand" | translate }}</th>
                    <th scope="col" style="border-bottom: 1px solid #ccc">{{ "Model" | translate }}</th>
                    <th scope="col" style="border-bottom: 1px solid #ccc">{{ "Mileage" | translate }}*</th>
                </tr>
                </thead>
                
                <tbody>  
                    <tr *ngFor=" let vehicleData of vehicleData let index = index"   >
                        <td  style="text-align: center; height: 3rem; border-bottom: 1px solid #ccc"> <input  [(ngModel)]="vehicleData.Plate"  oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')" matInput type="text" maxlength="20"></td>
                        <td  style="text-align: center; height: 3rem; border-bottom: 1px solid #ccc"> <input  [(ngModel)]="vehicleData.VIN"  oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')" matInput type="text" maxlength="20"></td>
                        <td  style="text-align: center; height: 3rem; border-bottom: 1px solid #ccc"> 
                          <mat-form-field class="vehicle-autocomplete-field">
                            <input
                              matInput
                              type="text"
                              maxlength="20"
                              [(ngModel)]="vehicleData.Brand"
                              [matAutocomplete]="brandAuto"
                              (ngModelChange)="onVehicleBrandInputChange(index, $event)"
                              (blur)="validateVehicleBrand(index)"
                            />
                            <mat-autocomplete
                              #brandAuto="matAutocomplete"
                              (optionSelected)="onVehicleBrandSelected(index, $event.option.value)"
                              [displayWith]="getBrandName"
                            >
                              <mat-option
                                *ngFor="let brand of vehicleBrandOptionsByRow[index]"
                                [value]="brand"
                              >
                                {{ brand.brandName }}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                          <div *ngIf="vehicleBrandInvalidByRow[index]" class="vehicle-field-error">
                            Selecciona una marca válida.
                          </div>
                        </td>
                        <td  style="text-align: center; height: 3rem; border-bottom: 1px solid #ccc"> 
                          <mat-form-field class="vehicle-autocomplete-field">
                            <input
                              matInput
                              type="text"
                              maxlength="20"
                              [(ngModel)]="vehicleData.ModelDescription"
                              [matAutocomplete]="modelAuto"
                              (ngModelChange)="filterVehicleModels(index, $event)"
                              (blur)="validateVehicleModel(index)"
                              [disabled]="!selectedVehicleBrandIdByRow[index]"
                            />
                            <mat-autocomplete
                              #modelAuto="matAutocomplete"
                              (optionSelected)="onVehicleModelSelected(index, $event.option.value)"
                            >
                              <mat-option
                                *ngFor="let model of vehicleModelOptionsByRow[index]"
                                [value]="model"
                              >
                                {{ model }}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                          <div *ngIf="vehicleModelInvalidByRow[index]" class="vehicle-field-error">
                            Selecciona un modelo válido.
                          </div>
                        </td>
                        <td  style="text-align: center; height: 3rem; border-bottom: 1px solid #ccc"> <input  [(ngModel)]="vehicleData.Mileage"  oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')" matInput type="text" maxlength="20"></td>
                    
                    </tr>
                </tbody>

            </table>
    </mat-tab>

    
  </mat-tab-group>

        <mat-dialog-actions 
        align="center" 
        [ngClass]="{'contenido-deshabilitado': !isLoadingSave}"
        >
            <button class="dialog__button" [mat-dialog-close]>
            {{"Cancel" | translate}}
            </button>
            <button
            class="dialog__button"
            [ngClass]="false? 'dialog__button--disabled' : 'dialog__button--fill'"
            (click)="onSaveCreateclient()"
            [disabled]= "formsValidations() "
            >
            {{"ButtonSave" | translate}}
            </button>
        </mat-dialog-actions>

  </div>
</main>